import styled from "@emotion/native";

export const Container = styled.View({
	marginVertical: 5
});

export const Title = styled.View({
	marginBottom: 12,
});

export const Body = styled.View({
	marginBottom: 12,
});

export const Caption = styled.View({});

export const Pin = styled.View({
	marginTop: -32,
	marginBottom: 6,
	alignItems: "center",
	justifyContent: "center",
});
